window.tinyMCE.PluginManager.add('footnotes', function (editor) {
  const footnoteIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<path d="M6 4 L6 20 L10 16 L14 20 L18 16 L18 4 Z M8 6 L8 14 L10 12 L12 14 L12 6 Z" />' +
    '</svg>';
  editor.ui.registry.addIcon('customFootnotes', footnoteIcon);

  function openFootnoteDialog() {
    editor.windowManager.open({
      title: 'Insert Footnote',
      body: {
        type: 'panel',
        items: [
          {
            type: 'textarea',
            name: 'footnoteText',
            label: 'Footnote Text'
          }
        ]
      },
      buttons: [
        {
          text: 'Insert',
          type: 'submit',
          primary: true
        },
        {
          text: 'Cancel',
          type: 'cancel'
        }
      ],
      onSubmit: function (api) {
        const data = api.getData();
        const footnoteText = data.footnoteText;

        // Generate a unique ID for the footnote
        const footnoteId = `footnote-${Date.now()}`;

        // Get the next footnote number
        const footnoteNumber = getNextFootnoteNumber();

        // Insert the footnote marker at the cursor position
        const markerContent = `<sup id="ref-${footnoteId}" class="footnote-ref"><a href="#${footnoteId}">[${footnoteNumber}]</a></sup>`;
        editor.insertContent(markerContent + ' ');

        // Create the footnote element
        const footnoteElement = editor.dom.create(
          'div',
          {
            id: footnoteId,
            class: 'footnote'
          },
          `<sup><a href="#ref-${footnoteId}">[${footnoteNumber}]</a></sup> ${footnoteText}`
        );

        // Ensure footnotes container exists and add footnote content to it
        ensureFootnotesContainer();
        const footnotesContainer = editor.getBody().querySelector('.footnotes-container');
        footnotesContainer.appendChild(footnoteElement);

        api.close();
      }
    });
  }

  function getNextFootnoteNumber() {
    const footnotes = editor.getBody().querySelectorAll('.footnote');
    return footnotes.length + 1;
  }

  function ensureFootnotesContainer() {
    let footnotesContainer = editor.getBody().querySelector('.footnotes-container');
    if (!footnotesContainer) {
      footnotesContainer = editor.dom.create('div', { class: 'footnotes-container' });
      editor.getBody().appendChild(footnotesContainer);
      const hr = editor.dom.create('hr', { class: 'footnotes-separator' });
      footnotesContainer.appendChild(hr);
    }
  }

  editor.ui.registry.addButton('footnotes', {
    icon: 'customFootnotes', // Use the customFootnotes icon
    tooltip: 'Insert Footnote', // Set the tooltip for the button   \
    onAction: openFootnoteDialog
  });

  return {
    getMetadata: function () {
      return {
        name: 'Footnotes Plugin'
      };
    }
  };
});
